// import { AppConfig } from '../app.config';

import type { Environment } from './environment.interface';

export const env: Environment = {
  production: true,
  name: 'Production',
  webSocketURL: 'wss://ws.fantaz.com',
  baseURL: 'https://www.fantaz.com',
  CognitoUrl: 'https://auth.fantaz.com',
  gameFileHost: 'https://www.fantaz.com/games-store/',
  apiBaseUrl: 'https://www.fantaz.com',
  UPLOAD_CUSTOMER_CARD: false,
  devToolDetection: true,
  zendeskDomain: 'fantaz.zendesk.com',
  showScoresWhileTournamentIsInProgress: false,
  autocomplete: {
    enabled: true,
    provider: 'google',
    config: {
      google: {
        apiKey: 'AIzaSyDe2TnR8ws3kPIRKXKcBO_aZmLB6L84Ovk',
      },
      smarty: {
        apiKey: '171091271069604852',
      },
    },
  },
  gtmConfig: {
    GTM_ID: 'GTM-T7W9QJV',
    GTM_AUTH: 'jcwLZOSAxo6ZnRqXtdLfOQ',
    GTM_PREVIEW: 'env-1',
  },
  tsevoConfig: {
    SSN_ALLOWED: true,
    FULL_SSN_ALLOWED: true,
    apiUrl: 'https://api.gidx-service.com/v3.0/api/',
  },
  Auth: {
    identityPoolId: 'us-east-1:3585e66e-fb63-4a0b-8bce-1a1656d94124',
    region: 'us-east-1',
    userPoolId: 'us-east-1_w7lpH9M45',
    userPoolWebClientId: '5q0mk4krrh2q9ipngog89bcn6c',
    mandatorySignIn: true,
    authenticationFlowType: 'USER_PASSWORD_AUTH',
    oauth: {
      domain: 'auth.fantaz.com',
      scope: ['email', 'profile', 'openid', 'aws.cognito.signin.user.admin'],
      redirectSignIn: 'https://www.fantaz.com/auth/federated-signin',
      redirectSignOut: 'https://www.fantaz.com',
      responseType: 'code',
    },
    AWSPinpoint: {
      appId: '2088546d9cb94a9d9baa9c0933ce07a6',
      region: 'us-east-1',
      mandatorySignIn: false,
    },
  },
  notifications: {
    NovuApplicationIdentifier: 'fjkL7lM4kTL8',
  },
  fBApi: {
    fbApiKey: '1721608741422878',
    xfbml: true,
    version: 'v2.10',
  },
  reCaptcha: {
    siteKeyV3: '6LdNq5UpAAAAAAaB1R3bHlJ_irzeDdOeOZFwf-g0',
    siteKeyV2: '6LczZMwpAAAAALpf6ZZQ9SYXBaZw2oxjb6yWOpO8',
  },
  cognitoAdvancedSecurity: true,
};

export const environment = env;
